export const enum WorkflowTypes {
    selectATrailer,
    findATrailer,
    virtualRedTag,
}

export const VIRTUAL_RED_TAG_ORIGIN = 'virtualRedTag';
